import { render, staticRenderFns } from "./ReportColumnsModal.vue?vue&type=template&id=2f7265e2&"
import script from "./ReportColumnsModal.vue?vue&type=script&lang=js&"
export * from "./ReportColumnsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports